import React, { useState } from 'react';
import { Button, Message } from '@getro/rombo';
import { Mail } from 'lucide-react';
import { useHistory } from 'react-router-dom';
import { Box, Text } from 'rebass/styled-components';

import { SocialOAuthButtons } from '../../../components/molecules/socialOAuthButtons';
import { openChat } from '../../../helpers/supportChat';

export const SignUp = () => {
  const [oAuthError, setOAuthError] = useState(null);
  const history = useHistory();

  const onClickSignUp = (mode) => {
    history.push(`/welcome/profile/${mode}`);
  };

  return (
    <>
      <Text lineHeight="24px">
        You’ve been invited to be a network administrator. Create an account to get started.
      </Text>
      <Box mt="32px">
        <SocialOAuthButtons
          onSuccess={() => {
            onClickSignUp('social');
            setOAuthError(null);
          }}
          onError={(e) => {
            setOAuthError(e);
          }}
        />
        <Button
          mt="8px"
          icon={Mail}
          variant="secondary"
          width="100%"
          sx={{ gap: '16px', justifyContent: 'center' }}
          onClick={() => onClickSignUp('email')}
        >
          Continue with email
        </Button>
        {!!oAuthError && (
          <Message
            mt="8px"
            type="error"
            content={
              oAuthError?.status === 401 ? (
                oAuthError.data?.error
              ) : (
                <Text>
                  There was an unexpected error, please try again or{' '}
                  <Text as="span" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openChat}>
                    contact us
                  </Text>
                  .
                </Text>
              )
            }
          />
        )}
      </Box>
    </>
  );
};
